import React from "react"
import styled from "styled-components"
import Options from "../../constants/home/whatWeDoOptions"
import { Link } from "gatsby"

const WhatWeDo = () => {
  return (
    <Wrapper>
      <div className="what-center">
        <h2>What we do</h2>
        <div className="blocks">
          {Options.map((item, index) => {
            return (
              <div key={index} className="block-container">
                <Link to={item.link}>
                
                <div key={index} className="block">
                <div className="line-10-black" />

                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
                </Link>
              </div>
            )
          })}
         
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  margin-top: 70px;
  h2 { margin-left: 20px; font-size: 30px; line-height: 47px; }
  .blocks { display: flex; flex-direction: column; width: 100vw; }
  .line-10-black { border-top: 10px solid var(--clr-primary-5); position:absolute; top: 0; left: -1px; width: 100.50%;}
  .block {
    position: relative;
    border-radius: var(--radius);
    border: 1px solid var(--clr-grey-9);
    margin-bottom: 40px;
    /* padding: 2.5rem 2rem 1rem; */
    padding: 30px 30px 0px;
    background: var(--clr-white);
    color: var(--clr-primary-5);
    height: 100%;
    :hover {
      transition: var(--transition);
      box-shadow: var(--light-shadow);    
      .line-10-black { border-top: 16px solid var(--clr-primary-2); transition: var(--transition);}
    }
  }
  h3 { font-size: 22px; line-height: 35px; } 
  p { font-size: 12px; line-height: 190%; color: var(--clr-primary-4); }

  @media (min-width: 360px) { .blocks {padding: 0 49px;} }
  @media screen and (min-width: 768px) {
    margin-top: 13rem;
    h2 {font-size: 32px;}
    .blocks {flex-direction: row;padding: 0 0px;}
    .block-container{margin-right: 24px; :last-child{margin-right: 0px;}}

  }
  @media (min-width: 1024px) {
    h2 { font-size: 30px; margin-left: 173px; } 
    .blocks { padding: 0 153px; }
  }
  @media (min-width: 1025px) {
    width:85vw; margin: 13rem auto 0; max-width: 1170px;
    .blocks {padding: 0;width: 100%; margin-top: 51px; }    
    h2 { font-size: 46px; line-height: 72px; margin-left: 0px; } 
    h3 { font-size: 28px; line-height: 34.13px; } 
    p { font-size: 16px; }
  }
`

export default WhatWeDo
